import { useContext, useLayoutEffect, useSyncExternalStore } from "react";
import { RouteBodyRetentionContext } from "#route-body-retention-context";

const canReleaseWithoutOwner = () => true;
const subscribeWithoutOwner = () => () => {};
const retainWithoutOwner = () => () => {};

export function useRouteBodyCanRelease(): boolean {
  const retention = useContext(RouteBodyRetentionContext);
  return useSyncExternalStore(
    retention?.subscribe ?? subscribeWithoutOwner,
    retention?.canRelease ?? canReleaseWithoutOwner,
    canReleaseWithoutOwner,
  );
}

/** Imperative overlays acquire before native presentation, including same-tick navigation. */
export function useRouteBodyRetainer(): () => () => void {
  return useContext(RouteBodyRetentionContext)?.retain ?? retainWithoutOwner;
}

/** No-op outside an explicit retention owner; this never saves or dismisses anything. */
export function useRetainRouteBody(shouldRetain: boolean): void {
  const retention = useContext(RouteBodyRetentionContext);
  useLayoutEffect(() => {
    if (shouldRetain) {
      return retention?.retain();
    }
  }, [retention, shouldRetain]);
}
